import { css } from '@emotion/react';
import React from 'react';

import { fontStyles } from '~src/theme/fontStyles';

import { colors } from '../theme/colors';
import { mediaQueries } from '../theme/mediaQueries';
import { DialogCloseButton } from '../ui/dialog-close-button';

interface LocationModalLayoutProps {
  title: string;
  mapElement?: React.ReactElement;
  listElement: React.ReactElement;
  buttonElement: React.ReactElement;
  searchElement?: React.ReactElement;
  onClose: () => void;
}

export const LocationModalLayout: React.FC<LocationModalLayoutProps> = ({
  title,
  mapElement,
  listElement,
  buttonElement,
  searchElement,
  onClose,
}) => {
  return (
    <div css={styles.wrapper}>
      <div>
        <div aria-level={2} css={styles.title} role="heading">
          {title}
        </div>
        <DialogCloseButton css={styles.closeButton} onClose={onClose} />
      </div>
      <div
        css={{
          display: 'flex',
          flexGrow: 1,
          overflow: 'hidden',
          [mediaQueries.L]: {
            flexDirection: 'column',
          },
        }}
      >
        {mapElement && (
          <div
            css={{
              overflow: 'hidden', // prevent tooltip from overflow
              position: 'relative',
              width: '50%',
              minHeight: '200px',
              [mediaQueries.L]: {
                width: '100%',
              },
            }}
          >
            {mapElement}
            {searchElement && (
              <div
                css={{
                  zIndex: 1000,
                  position: 'absolute',
                  top: '16px',
                  left: '16px',
                  right: '16px',
                  [mediaQueries.L]: {
                    top: '20px',
                    left: '20px',
                    right: '20px',
                  },
                }}
              >
                {searchElement}
              </div>
            )}
          </div>
        )}
        <div
          css={{
            display: 'flex',
            flexGrow: 2,
            flexDirection: 'column',
            overflow: 'hidden',
            width: mapElement ? '50%' : undefined,
            borderTop: `1px solid ${colors.neutral90}`,
            [mediaQueries.L]: {
              width: '100%',
            },
          }}
        >
          <div
            css={{
              overflow: 'auto',
              padding: '0 16px',
              borderBottom: `1px solid ${colors.neutral90}`,
              marginTop: '-1px',
            }}
          >
            {listElement}
          </div>
          <div
            css={{
              padding: '16px 20px',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              flexShrink: 0, // iphone fix
              justifyContent: 'flex-end',
            }}
          >
            {buttonElement}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
    width: '100%',
  }),
  title: css({
    height: '60px',
    ...fontStyles.px18_22,
    padding: '19px 16px',
    whiteSpace: 'nowrap',
    [mediaQueries.S]: {
      ...fontStyles.px16_20,
      padding: '20px 16px',
    },
  }),
  closeButton: css({
    position: 'absolute',
    top: '22px',
    right: '16px',
    height: '14px',
    width: '14px',
  }),
};
